import { getFormattedLinkToBrowser } from '~/utils/url';

export const GENERAL_CONDITIONS_LINK = getFormattedLinkToBrowser(
  'https://psffiles.blob.core.windows.net/psfcontratos/termos/seguros/assurant/protecao-perda-de-renda/condicoes-gerais-contratacao.pdf'
);
